var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.667,
    height: 18,
    viewBox: "0 0 18.667 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-heart",
    "data-name": "Icon ionic-ios-heart",
    d: "M17.016,3.937h-.045a5.1,5.1,0,0,0-4.263,2.34,5.1,5.1,0,0,0-4.263-2.34H8.4A5.081,5.081,0,0,0,3.375,9.022,10.974,10.974,0,0,0,5.52,14.994a37.631,37.631,0,0,0,7.188,6.943A37.631,37.631,0,0,0,19.9,14.994a10.974,10.974,0,0,0,2.145-5.972A5.081,5.081,0,0,0,17.016,3.937Z",
    transform: "translate(-3.375 -3.938)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2a0d4d2ee37b8333fa300a08378e261c.svg";
export { ForwardRef as ReactComponent };